import React = require('react');
import { EditItemCompCore } from '../EditItemCompCore';
import { IEditItemCompProps, IEditItemCompState } from '../../../interfaces/layout/blocks/IUser';
import { IProfileFormFieldsProps, ProfileFormFields } from '../ProfileFormFields';

interface IProfileViewProps extends IEditItemCompProps{
}

interface IProfileViewState extends IEditItemCompState {
}

export default class ProfileView extends EditItemCompCore{

    constructor(props:IProfileViewProps){
        super(props);
    }

    render() {
        var profileClasses:string = 'profil_data';
		if ( this.state.data.deathDate !== '' ) {
			profileClasses += ' death';
		}
        var ProfileFormFieldsData:IProfileFormFieldsProps = this.state.ProfileFormFieldsData;
        return (
            <div>
                <div className="header">
					{/* <div className="row">
						<h3 className="box">
							Profilok / { this.state.data.firstName} { this.state.data.type}
						</h3>
						<div className="box right share_box">
							<div>
								<span>
									megosztás
								</span>
							</div>
							<a>
								<img src="/img/mail.jpg" />
							</a>
							<a>
								<img src="/img/twitter.jpg" />
							</a>
							<a>
								<img src="/img/facebook.jpg" />
							</a>
							<a>
								<img src="/img/google.jpg" />
							</a>
						</div>
					</div> */}

					<div className={ profileClasses }>
						<div className="row col3">
							<div className="box">
								<img src={ this.state.data.img !== null && this.state.data.img !== '' ? this.state.data.img.replace('_medium.','_small.') : '/img/default.png' } />
							</div>
							<div className="box">
								<h1>
									{ this.state.data.lastName} { this.state.data.firstName }
								</h1>
								<strong className="familyType">
									{ this.state.data.type}
								</strong>
								<div className="date">
									Született: { this.state.data.birthPlaceCity }. { this.state.data.birthDate}.
								</div>

                                { this.state.data.deathDate !== ''?<div className="death_date">
									Elhunyt: { this.state.data.deathDate }.
								</div>:'' }

								<div className="place_time">
									Lakcím: { this.state.data.city}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="body">
                    <ProfileFormFields
                        itemPlaces    = { ProfileFormFieldsData.itemPlaces }
                        itemSchools   = { ProfileFormFieldsData.itemSchools }
                        itemJobs      = { ProfileFormFieldsData.itemJobs }
                        itemHonors    = { ProfileFormFieldsData.itemHonors }
                        itemArmy      = { ProfileFormFieldsData.itemArmy }
                        itemLanguages = { ProfileFormFieldsData.itemLanguages }
                        itemHobbies   = { ProfileFormFieldsData.itemHobbies }
                        nameDayMonth  = { ProfileFormFieldsData.nameDayMonth }
                        nameDayDay    = { ProfileFormFieldsData.nameDayDay }
                        note          = { ProfileFormFieldsData.note }
                        religion      = { ProfileFormFieldsData.religion }
                        viewMode      = { true }
                     />
				</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/proifle/ProfileView.tsx